import React from 'react'
import styles from './StepCounter.module.css'

type StepCounterProps = {
    /** 全ステップ数 */
    totalSteps?: number
    /** 現在アクティブなステップのインデックス（0始まり） */
    currentIndex: number
}

// 縦型EF用ステッパー(画像 vertical_stepper/step{N}.png)。
const StepCounter = ({ totalSteps = 5, currentIndex }: StepCounterProps) => {
    const step = Math.min(Math.max(currentIndex + 1, 1), totalSteps)

    return (
        <img
            className={styles.image}
            src={`/entry_form_slide_app/steps/vertical_stepper/step${step}.png`}
            alt={`ステップ ${step}/${totalSteps}`}
        />
    )
}

export default StepCounter
